const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const AT = require("../../core/vault/ActionTypes");
const OpsParentAcc = require("../vault/OpsParentAcc");
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const CopyTable = require("../../office/data/CopyTable");
const UnderlineView = require("../../office/UnderlineView");
const SubscriptionSummaryAccount = require("./SubscriptionSummaryAccount");
const EditableCard = require("./EditableCard");
const EditableAddress = require("./EditableAddress");
const Checkbox = require("../../core/view/Checkbox");

const styles = require("./styles/SubscriptionBilling.css");

module.exports = createReactClass({
	displayName: "SubscriptionBilling",

	propTypes: {
		account: PT.object.isRequired,
		hasClassWallet: PT.bool,
		onContinue: PT.func,
		dispatch: PT.func.isRequired,
	},

	getInitialState: function() {
		return {
			agreeBillingError: false,
		};
	},

	setAgree: function(value) {
		this.props.dispatch({
			type: AT.SUBSCRIPTION_CHANGE_SET_AGREED_TO_BILLING,
			value,
		});
		this.setState({agreeBillingError: false});
	},

	updateBilling: function(vals) {
		this.props.dispatch({
			type: AT.SAVE_PARENT_FORM_REQUEST,
			section: "billing",
			vals,
		});
	},

	updateCard: function(vals) {
		this.props.dispatch({
			type: AT.SAVE_PARENT_FORM_REQUEST,
			section: "creditCard",
			vals,
		});
	},

	onContinue: function() {
		const {account} = this.props;
		if (OpsParentSubChange.needsToAgreeToBilling(account)) {
			this.setState({agreeBillingError: true});
			return;
		}
		this.props.onContinue();
	},

	renderAgree: function() {
		const {account} = this.props;
		if (!OpsParentSubChange.canAgreeToBilling(account)) {
			return null;
		}

		const acceptError = this.state.agreeBillingError
			? CopyTable.getFormErrorCopy()["E_MISSING"]
			: null;
		const subscriptionNumInfo = {
			[account.subChangeState.newPlanType]: 1,
		};
		const currValue = account.subChangeState.agreedToBilling;

		return (
			<div className={styles.accept} ref={a => (this.acceptSection = a)}>
				<Checkbox
					className={styles.acceptCheck}
					text={CopyTable.getRecurringBillingCopy(subscriptionNumInfo)}
					onClick={() => this.setAgree(!currValue)}
					isErrored={this.state.agreeBillingError}
					isSelected={currValue}
					tabIndex={5}
				/>
				<div className={styles.error}>{acceptError}</div>
			</div>
		);
	},

	render: function() {
		const {account, hasClassWallet} = this.props;
		const billing = OpsParentAcc.getFormSection(account, "billing");
		// TODO: This feels a bit too hard-coded. A mechanism to autocompute this
		// text based on what the next step is according to OpsParentSubChange
		// functions might be better.
		const buttonText = OpsParentSubChange.needsShipping(account)
			? "Continue"
			: "Review";
		const warningText = CopyTable.getCardWarningCopy();
		const classWalletWarning = CopyTable.getClassWalletSubscriptionCopy();
		return (
			<div className={styles.main}>
				<div className={styles.title}>
					<UnderlineView text={"Billing Information"} />
				</div>
				<div className={styles.across}>
					<div className={styles.mainContent}>
						<div className={styles.formContainer}>
							<div className={styles.subtitle}>Payment Method:</div>
							<EditableCard
								{...account.shownCC}
								disableDelete={true}
								warningText={warningText}
								onUpdate={this.updateCard}
							/>
							<div className={styles.subtitleBetween}>Billing Address:</div>
							<EditableAddress
								initialAddress={billing}
								addressType="billing"
								onUpdate={this.updateBilling}
							/>
							{this.renderAgree()}
							<div className={styles.largeWarning}>
								{hasClassWallet ? classWalletWarning : null}
							</div>
						</div>
					</div>
					<SubscriptionSummaryAccount
						account={account}
						showItemize={true}
						onContinue={this.onContinue}
						buttonText={buttonText}
						showError={!!this.state.agreeBillingError}
						tabIndex={500}
					/>
				</div>
			</div>
		);
	},
});
